var map = {
	"./": 2812,
	"./App.test": 6029,
	"./App.test.js": 6029,
	"./css/App.css": 1154,
	"./css/Card.css": 9153,
	"./css/Deck.css": 3316,
	"./css/index.css": 8195,
	"./images/3-of-cups.png": 4628,
	"./images/4-of-cups.png": 3035,
	"./images/6-of-swords.png": 3860,
	"./images/7-of-cups.png": 6192,
	"./images/card-top-view.png": 6709,
	"./images/death.png": 6501,
	"./images/deck-sideways.png": 4542,
	"./images/deck-top-view.png": 3286,
	"./images/high-priestess.png": 1583,
	"./images/lovers.png": 5198,
	"./images/moon.png": 7224,
	"./images/strength.png": 2320,
	"./images/wheel-of-fortune-resized.png": 1473,
	"./index": 2812,
	"./index.js": 2812,
	"./js/cards": 5342,
	"./js/cards.json": 5342,
	"./js/components/App": 152,
	"./js/components/App.js": 152,
	"./js/components/Card": 7281,
	"./js/components/Card.js": 7281,
	"./js/components/Deck": 3522,
	"./js/components/Deck.js": 3522,
	"./js/utilities/pickCards": 5225,
	"./js/utilities/pickCards.js": 5225,
	"./reportWebVitals": 9031,
	"./reportWebVitals.js": 9031,
	"./setupTests": 9472,
	"./setupTests.js": 9472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;